// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file forms/v1/options.proto (package forms.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file forms/v1/options.proto.
 */
export const file_forms_v1_options: GenFile =
	/*@__PURE__*/
	fileDesc("ChZmb3Jtcy92MS9vcHRpb25zLnByb3RvEghmb3Jtcy52MSJcChFQYWdpbmF0aW9uT3B0aW9ucxIRCglwYWdlX3NpemUYASABKAUSFwoKcGFnZV90b2tlbhgCIAEoCUgAiAEBEgwKBHNraXAYAyABKAVCDQoLX3BhZ2VfdG9rZW4igQEKCURhdGVSYW5nZRIvCgZiZWZvcmUYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQESLgoFYWZ0ZXIYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQFCCQoHX2JlZm9yZUIICgZfYWZ0ZXJiBnByb3RvMw", [
		file_google_protobuf_timestamp,
	]);

/**
 * @generated from message forms.v1.PaginationOptions
 */
export type PaginationOptions = Message<"forms.v1.PaginationOptions"> & {
	/**
	 * @generated from field: int32 page_size = 1;
	 */
	pageSize: number;

	/**
	 * @generated from field: optional string page_token = 2;
	 */
	pageToken?: string | undefined;

	/**
	 * @generated from field: int32 skip = 3;
	 */
	skip: number;
};

/**
 * @generated from message forms.v1.PaginationOptions
 */
export type PaginationOptionsJson = {
	/**
	 * @generated from field: int32 page_size = 1;
	 */
	pageSize?: number;

	/**
	 * @generated from field: optional string page_token = 2;
	 */
	pageToken?: string;

	/**
	 * @generated from field: int32 skip = 3;
	 */
	skip?: number;
};

/**
 * Describes the message forms.v1.PaginationOptions.
 * Use `create(PaginationOptionsSchema)` to create a new message.
 */
export const PaginationOptionsSchema: GenMessage<PaginationOptions, { jsonType: PaginationOptionsJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_options, 0);

/**
 * @generated from message forms.v1.DateRange
 */
export type DateRange = Message<"forms.v1.DateRange"> & {
	/**
	 * @generated from field: optional google.protobuf.Timestamp before = 1;
	 */
	before?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp after = 2;
	 */
	after?: Timestamp | undefined;
};

/**
 * @generated from message forms.v1.DateRange
 */
export type DateRangeJson = {
	/**
	 * @generated from field: optional google.protobuf.Timestamp before = 1;
	 */
	before?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp after = 2;
	 */
	after?: TimestampJson;
};

/**
 * Describes the message forms.v1.DateRange.
 * Use `create(DateRangeSchema)` to create a new message.
 */
export const DateRangeSchema: GenMessage<DateRange, { jsonType: DateRangeJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_options, 1);
